// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { ErrorAccordionComponent } from 'components/error-accordion/error-accordion.component';
import { ErrorComponent } from 'components/error/error.component';
// Contexts
import { LayoutContextProvider } from 'components/layout/contexts/layout.context';
// Constants
import { ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS } from './constants/entrypoint-orchestrator-uncategorized.constants';
// Hooks
import { useAppContextConsumerHook } from 'contexts/app.context';
// Styles
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';
import { EntrypointOrchestratorUncategorizedStyled } from './entrypoint-orchestrator-uncategorized.component.styled';
// Translations
import { ORDER_STATUS } from './translations/entrypoint-orchestrator-uncategorized.translations';

const EntrypointOrchestratorUncategorizedComponent = (): React.JSX.Element => {
  const { currentState } = useAppContextConsumerHook();

  return (
    <LayoutContextProvider>
      <HeaderLayoutContentFullHeightStyled>
        <EntrypointOrchestratorUncategorizedStyled>
          <ErrorComponent {...ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS} />
          <ErrorAccordionComponent
            {...{
              error: currentState,
              description: <FormattedMessage id={ORDER_STATUS} values={{ currentState }} />,
            }}
          />
        </EntrypointOrchestratorUncategorizedStyled>
      </HeaderLayoutContentFullHeightStyled>
    </LayoutContextProvider>
  );
};

export { EntrypointOrchestratorUncategorizedComponent };
